/**
 * Formata data (sem hora) no padrão brasileiro DD/MM/AAAA.
 * Aceita ISO (YYYY-MM-DD), Date ou string já em pt-BR.
 *
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export function formatDatePtBR(value) {
  if (value == null || value === "") return "—";

  const trimmed = String(value).trim();
  if (trimmed === "0000-00-00") return "—";

  const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trimmed);
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(trimmed)) return trimmed;

  const d = value instanceof Date ? value : new Date(trimmed);
  if (!Number.isNaN(d.getTime())) {
    return d.toLocaleDateString("pt-BR");
  }

  return trimmed;
}

export const PLATFORM_TZ = "America/Araguaina";

/**
 * Relógio HH:mm no fuso da plataforma (America/Araguaina), igual ao restante do XPro.
 * String MySQL sem offset já é parede Araguaína — não passa por Date/UTC.
 * ISO com Z/offset é instante real e converte para Araguaína.
 */
export function formatTimePtBR(value) {
  if (value == null || value === "") return "";
  if (typeof value === "string") {
    const trimmed = value.trim();
    const mysql = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?(Z|[+-]\d{2}:?\d{2})?$/.exec(
      trimmed
    );
    if (mysql && !mysql[7]) return `${mysql[4]}:${mysql[5]}`;
  }
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: PLATFORM_TZ,
  });
}

/**
 * Formata data/hora no mesmo padrão do chat (MessageItem): pt-BR, fuso America/Araguaina (Araguaína).
 * A API retorna datetimes no fuso Araguaína (UTC-03:00) como "YYYY-MM-DD HH:mm:ss".
 * Para não reinterpretar como UTC no JS, strings nesse formato são apenas reordenadas
 * para DD/MM/YYYY HH:mm:ss (sem vírgula), igual ao parseDisplayDate do MessageItem.
 *
 * @param {string|Date|null|undefined} value - valor vindo da API ou Date
 * @returns {string} "DD/MM/YYYY HH:mm:ss" ou "—" se inválido
 */
export function formatDateTimePtBR(value) {
  if (value == null || value === "") return "—";

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed === "0000-00-00 00:00:00") return "—";
    const mysqlRegex = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(\.\d+)?(Z?)$/;
    if (mysqlRegex.test(trimmed)) {
      const normalized = trimmed.replace("T", " ").split(".")[0];
      const [datePart, timePart] = normalized.split(" ");
      if (datePart && timePart) {
        const [year, month, day] = datePart.split("-");
        return `${day}/${month}/${year} ${timePart}`;
      }
    }
  }

  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("pt-BR");
}
